<div matRipple class="button">
    <sc-padding [fitHeight]="true">
        <sc-flex [fitHeight]="true" [vertical]="true" [centered]="true">
            <sc-icon iconClass="fa-3x {{iconCSS}}"></sc-icon>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <div class="label">{{'reload yard clients' |
                translate:[dictionaryKey,
                translationService.language]}}</div>
        </sc-flex>
    </sc-padding>
</div>